import { axios } from '../../clients/axios'
import { API_URL } from '../../config/env'

export default {
  namespaced: true,
  state: {},
  actions: {
    async createSOAAsyncJob(_, params) {
      const { tenantId } = params
      try {
        const response = await axios.post(`${API_URL}/asyncJobs`, {
          parameters: {
            tenantId
          },
          type: 'GENERATE_SOA_LESSOR'
        })

        return response.data
      } catch (error) {
        return Promise.reject('Error creating async job:', error)
      }
    },
    async fetchAsyncJob(_, jobId) {
      try {
        const response = await axios.get(`${API_URL}/asyncJobs/${jobId}`)

        return response.data
      } catch (error) {
        Promise.reject('Error fetching downloads:', error)
      }
    }
  }
}
